export var FETCH_LOBBY_GAMES = "FETCH_LOBBY_GAMES";
export var SUCCESS_FETCH_LOBBY_GAMES = "SUCCESS_FETCH_LOBBY_GAMES";
export var FAILURE_FETCH_LOBBY_GAMES = "FAILURE_FETCH_LOBBY_GAMES";
export var FETCH_FASTSPORT_GAMES_TOKEN = 'FETCH_FASTSPORT_GAMES_TOKEN';
export var SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN = 'SUCCESS_FETCH_FASTSPORT_GAMES_TOKEN';
export var FAILURE_FETCH_FASTSPORT_GAMES_TOKEN = 'FAILURE_FETCH_FASTSPORT_GAMES_TOKEN';
export var FETCH_MORE_GAMES = "FETCH_MORE_GAMES";
export var SUCCESS_FETCH_MORE_GAMES = "SUCCESS_FETCH_MORE_GAMES";
export var FAILURE_FETCH_MORE_GAMES = "FAILURE_FETCH_MORE_GAMES";
export var FETCH_FILTER_TYPES = "FETCH_FILTER_TYPES";
export var SUCCESS_FETCH_FILTER_TYPES = "SUCCESS_FETCH_FILTER_TYPES";
export var FAILURE_FETCH_FILTER_TYPES = "FAILURE_FETCH_FILTER_TYPES";
export var FETCH_FILTER_PROVIDERS = "FETCH_FILTER_PROVIDERS";
export var SUCCESS_FETCH_FILTER_PROVIDERS = "SUCCESS_FETCH_FILTER_PROVIDERS";
export var FAILURE_FETCH_FILTER_PROVIDERS = "FAILURE_FETCH_FILTER_PROVIDERS";
export var SHOW_GAMES_FILTER_MODAL = "SHOW_GAMES_FILTER_MODAL";
export var HANDLE_SELECT_FILTER_OPTION = "HANDLE_SELECT_FILTER_OPTION";
export var SHOW_FILTER_CONFLICT = "SHOW_FILTER_CONFLICT";
export var HIDE_FILTER_CONFLICT = "HIDE_FILTER_CONFLICT";
export var CANCEL_FILTERING = "CANCEL_FILTERING";
export var GET_GAMES = "GET_GAMES";
export var SUCCESS_GET_GAMES = "SUCCESS_GET_GAMES";
export var FAILURE_GET_GAMES = "FAILURE_SEARCH_GAMES";
export var CLEAR_GET_GAMES = "CLEAR_SEARCH_GAMES";
export var SET_IS_TOP_GAMES = "SET_IS_TOP_GAMES";
export var SET_PROVIDER_SORT_TYPE = "SET_PROVIDER_SORT_TYPE";
export var SEARCH_GAMES = "SEARCH_GAMES";
export var SUCCESS_SEARCH_GAMES = "SUCCESS_SEARCH_GAMES";
export var FAILURE_SEARCH_GAMES = "FAILURE_SEARCH_GAMES";
export var FETCH_RANDOM_GAMES = "FETCH_RANDOM_GAMES";
export var SUCCESS_FETCH_RANDOM_GAMES = "SUCCESS_FETCH_RANDOM_GAMES";
export var FAILURE_FETCH_RANDOM_GAMES = "FAILURE_FETCH_RANDOM_GAMES";
export var CLEAR_RANDOM_GAMES = "CLEAR_RANDOM_GAMES";
export var FETCH_ALL_GAMES = "FETCH_ALL_GAMES";
export var SUCCESS_FETCH_ALL_GAMES = "SUCCESS_FETCH_ALL_GAMES";
export var FAILURE_FETCH_ALL_GAMES = "FAILURE_FETCH_ALL_GAMES";
export var PIN_GAME = "PIN_GAME";
export var UNPIN_GAME = "UNPIN_GAME";
export var FETCH_RECENT_VISITED_GAMES = "FETCH_RECENT_VISITED_GAMES";
export var SUCCESS_FETCH_RECENT_VISITED_GAMES = "SUCCESS_FETCH_RECENT_VISITED_GAMES";
export var FAILURE_FETCH_RECENT_VISITED_GAMES = "FAILURE_FETCH_RECENT_VISITED_GAMES";
export var OPEN_GAME = "OPEN_GAME";
export var SUCCESS_OPEN_GAME = "SUCCESS_OPEN_GAME";
export var FAILURE_OPEN_GAME = "FAILURE_OPEN_GAME";
export var SEARCH_GAMES_BY_PROVIDER = "SEARCH_GAMES_BY_PROVIDER";
export var SUCCESS_SEARCH_GAMES_BY_PROVIDER = "SUCCESS_SEARCH_GAMES_BY_PROVIDER";
export var FAILURE_SEARCH_GAMES_BY_PROVIDER = "FAILURE_SEARCH_GAMES_BY_PROVIDER";
export var FETCH_ORDERED_GAMES = "FETCH_ORDERED_GAMES";
export var SUCCESS_FETCH_ORDERED_GAMES = "SUCCESS_FETCH_ORDERED_GAMES";
export var FAILURE_FETCH_ORDERED_GAMES = "FAILURE_FETCH_ORDERED_GAMES";
export var CLEAR_ORDERED_GAMES = "CLEAR_ORDERED_GAMES";



// WEBPACK FOOTER //
// ./src/actions/games/index.js